export default __webpack_public_path__ + "static/media/kaapi-5.fe21e4b1.jpg";